import React, { Component } from 'react'
import { connect } from "react-redux";
import '../../../assets/styles/components/detail-center.mobile/comment.mobile.scss'
import postIcon from '@/assets/images/icons/light/market_comment_icon_post.png'
import uploadpictures from '@/assets/images/icons/light/market_comment_post_icon_uploadpictures.png'
import like_normal from '@/assets/images/icons/light/market_comment_icon_like_normal.png'
import like_hit from '@/assets/images/icons/light/market_comment_icon_like_hit.png'
import comment_normal from '@/assets/images/icons/light/market_comment_icon_comment_normal.png'
import comment_hit from '@/assets/images/icons/light/market_comment_icon_comment_hit.png'
import icon_more from '@/assets/images/icons/light/market_comment_icon_more.png'
import followicon from '@/assets/images/icons/light/market_comment_icon_follow.png'
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { userActions } from '@/actions/user';
import { Converter, formatFunctions,utilsFunction } from '@/helpers/functions';
import { getSafe } from '@/helpers/global';
import { dataType } from '@/constants/data-type';
import { LOADING_TYPE } from '@/constants/app';
import { forumActions } from '@/actions/forum/forum.actions';
import { SERVICES_RESP } from '@/configurations';
import { openMarketCommentReport, openMarketCommentPost, openMarketCommentAllComment } from '@/actions/app';
import 'react-quill/dist/quill.snow.css';


class CommentMobile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowcomments: false,
            isthumbsup: false,
            iscomment: "",
            isreport: false,
            PostsData: null,
            load: true,
            cid: null,
            arrangementCommentData: null,
            replyName: null,
            isOpenImg: false,
            zoomImgUrl: "",
        }

    }

    render() {
        const { language } = this.props;
        const { isShowcomments, isthumbsup, iscomment, isreport, PostsData, load, replyName, isOpenImg, zoomImgUrl } = this.state;
        return (
            <div className="Comment_assembly">
                <LoadingLayer load={load} type={LOADING_TYPE.SKELETON} width={600} height={650} children={
                    <>
                        <rect x={10} y={10} width={135} height={30} ></rect>
                        <rect x={10} y={50} width={540} height={85} ></rect>
                        <rect x={10} y={145} width={540} height={85} ></rect>
                        <rect x={10} y={240} width={540} height={390} ></rect>
                        {/* <rect x={255} y={630} width={90} height={30} ></rect> */}
                    </>
                } />
                <div className="Comment-header-container">
                    {this.props.marketParams.stockCode && <div className="Comment-top-container" onClick={() => openMarketCommentPost(() => this.getPostList())}>
                        <img src={postIcon} />
                        <div className="Comment-span-container">{language.market_comment_post}</div>
                    </div>}
                </div>
                <div className="Comment-centre-container">
                    <div className="Comment-centrefor-container">
                        {isOpenImg ? <div className='comment-zoom-img' onClick={() => this.openZoomImg()}> <img src={zoomImgUrl} /> </div> : ""}
                        {PostsData?.map((opt, index) => {
                            return (
                                <div className="Comment-centre-container" key={opt.nid}>
                                    <div className="Comment-centrehead-container" id={'Comment-centrehead-container-' + index} >
                                        <div className='comment-info' >
                                            <div className="Comment-head-portrait Comment-item">
                                                <img src={opt.account_avatar ? opt.account_avatar : uploadpictures} />
                                            </div>
                                            <div className='comment-time' >
                                                <span className="Comment_span"> {opt?.account_nick}   </span>
                                                <div className="Comment-Creation-time Comment-item">{formatFunctions.dataFormat(Number(opt.created), dataType.SHORT_DATE)}</div>
                                            </div>
                                        </div>
                                        {opt.account_id !== this.props.userInfo.id && (opt.following == "N" ? <div className="Comment-isconcerned Comment-item" onClick={() => this.handfollow(opt, index)}>
                                            <img src={followicon} /><span>{language.market_comment_follow}</span>
                                        </div> :
                                            <div className="Comment-isconcernedtwo Comment-item" onClick={() => this.handunfollow(opt, index)}>
                                                <span>{language.market_comment_followed}</span>
                                            </div>)
                                        }
                                    </div>
                                    <div className="Comment-centrebody-container" id={'Comment-centrebody-container-' + index} >
                                        <h2>{opt.title && opt.title}</h2>
                                        <div className="comment_title ql-editor" dangerouslySetInnerHTML={{ __html: opt.summary }}></div>

                                        <div className="comment_imgs">
                                            {opt.attaches && ((opt.attaches).split(",")).map((opts, index) => {
                                                return (
                                                    <div className='comment_img' key={index} >
                                                        <img key={index} src={opts} onClick={() => utilsFunction.openZoomImg(opts,true)} />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    <div className="Comment-centrefooter-container" id={'Comment-centrefooter-container' + index} >
                                        <div className="Comment-centrebodyhead-container Comment-centrefooter-item" onClick={() => this.handthumbsup(opt, index)}>
                                            {opt.like == "N" ? <img src={like_normal} /> : <img src={like_hit} />}
                                            <span className="Give_the_thumbs-up" style={{ color: opt.like == "Y" ? '#1996e3' : '' }} >{opt.dlike_counts}</span>
                                        </div>
                                        <div className="Comment-centrebodycenter-container Comment-centrefooter-item" >
                                            {opt.nid == iscomment ? <img onClick={(e) => this.handcomment(e, opt)} src={comment_hit} /> : <img src={comment_normal} onClick={(e) => this.handcomment(e, opt)} />}
                                            <span className="Comment_comment" style={{ color: opt.nid == iscomment ? '#1996e3' : '' }} >{opt.comments_count}</span>
                                        </div>
                                        <div className="Comment-centrebodyfooter-container Comment-centrefooter-item">
                                            <img src={icon_more} onClick={(e) => this.handisreport(e, opt)} />
                                            {opt.nid == isreport ? <div className="Report_positioning" onClick={() => openMarketCommentReport(opt.nid, load, this.getPostList)} >{language.market_comment_report}</div> : <div></div>}
                                        </div>
                                    </div>
                                    {opt.nid == isShowcomments ?
                                        <div>
                                            <div className="Comment-cfooter-container" onClick={e => e.stopPropagation()} >
                                                <div className="Comment_input Comment-cfooter">
                                                    <input placeholder={replyName ? language.market_comment_reply + ' ' + replyName : language.market_comment}
                                                        maxlength={249} ref={e => this.commentInputRef = e} onFocus={() => this.setState({ isShowcomments: opt.nid })}
                                                        autoFocus
                                                        onKeyUp={(e) => { e.keyCode == 13 ? this.handsend(opt) : '' }}
                                                    />
                                                </div>
                                                <div className="Comment_send Comment-cfooter" onClick={() => this.handsend(opt)}  >{language.market_comment_send}</div>
                                            </div>
                                        </div>
                                        : <div></div>}
                                    <div className="Comment-centrecomment-container"  >
                                        {opt?.data?.rows && opt.data.rows.map((ritem, rindex) => {
                                            if (ritem.pid_account_id) {
                                                return (
                                                    <div className='Comment-centrecomment-container-reply' key={rindex} >
                                                        <span className='Comment-centrecomment-container-reply-name' >{ritem.account_nick + ' '}</span>
                                                        <span className='Comment-centrecomment-container-reply-reply'>{language.market_comment_reply + ' '}</span>
                                                        <span className='Comment-centrecomment-container-reply-name' >{ritem.pid_account_nick + ':'}</span>
                                                        <span className='Comment-centrecomment-container-reply-content'  >{ritem.content} </span>
                                                    </div>
                                                )
                                            } else {
                                                return (
                                                    <div className='Comment-centrecomment-container-comment' key={rindex} >
                                                        <span className='Comment-centrecomment-container-name' >{ritem.account_nick + ':'}<span className='Comment-centrecomment-container-content' >{ritem.content}</span></span>
                                                        {this.props.userInfo.id != ritem.account_id && <div className='Comment-centrecomment-container-reply-reply' onClick={() => this.handleReplyButton(ritem, rindex, opt)}   >{language.market_comment_reply} </div>}
                                                    </div>
                                                )
                                            }
                                        })}
                                    </div>
                                    {opt?.data?.rows?.length >= 5 && <div className='Comment-centrecomment-container-view-more' onClick={() => this.handleOpenMarketCommentAllComment(opt, index)}>{language.market_comment_view_more}</div>}
                                    <div id="Comment-last-container" className="Comment-last-container"></div>
                                </div>
                            )
                        })}
                    </div></div>
            </div>
        )
    }
    componentDidMount() {
        const { marketParams } = this.props;
        const { marketID, stockCode } = marketParams;
        this.props.innerRef(this)
        this.getPostList();
        document.addEventListener('click', this.hiddenButton)
    }
    componentDidUpdate(preProps) {
        const { language, marketParams } = this.props
        if (marketParams && preProps.marketParams !== marketParams) {
            this.setState({
                cid: null, replyName: null,
                isShowcomments: null, iscomment: null,
                isreport: null
            }, () => {
                this.getPostList()
            })
        }
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.hiddenButton)
    }
    openZoomImg(event) {
        let { isOpenImg, zoomImgUrl } = this.state
        if (isOpenImg) {
            zoomImgUrl = ""
        } else {
            zoomImgUrl = event.target.src
        }
        isOpenImg = !this.state.isOpenImg
        this.setState({ isOpenImg, zoomImgUrl })
    }
    handleOpenMarketCommentAllComment = (opt, index) => {
        let ChangeLayout = false
        if ((document.getElementById('Comment-centrehead-container-' + index).scrollHeight
            + document.getElementById('Comment-centrebody-container-' + index).scrollHeight
            + document.getElementById('Comment-centrefooter-container' + index).scrollHeight) > 350)
            ChangeLayout = true
        openMarketCommentAllComment(opt, () => this.getPostList(), ChangeLayout)
    }

    handleReplyButton = (ritem, rindex, opt) => {
        this.setState({
            cid: ritem.cid,
            replyName: ritem.account_nick,
            isShowcomments: opt.nid,
            iscomment: opt.nid
        }, () => {
        })
    }

    hiddenButton = () => {
        this.setState({
            isreport: '',
            //  iscomment: '', isShowcomments: ""
        })
    }
    handsend = (opt) => {
        const { cid } = this.state
        if (!this.commentInputRef.value) return
        if (cid) {
            const params = {
                cid: cid,
                body: this.commentInputRef.value,
            }
            this.commentInputRef.value = ''
            // this.setState({ load: true })
            this.props.replyComment(params, res => {
                if (res) {
                    this.setState({ isShowcomments: "", iscomment: "", cid: null, replyName: null })
                    this.getPostList()
                }
            })
        } else {
            const params = {
                nid: opt.nid,
                body: this.commentInputRef.value
            }
            this.commentInputRef.value = ''
            // this.setState({ load: true })
            this.props.writeComment(params, res => {
                if (res) {
                    this.setState({ isShowcomments: "", iscomment: "", cid: null, replyName: null })
                    this.getPostList()
                }
            })
        }
    }


    handfollow = (opt, index) => {
        const { PostsData } = this.state
        const { userInfo } = this.props;
        const { id } = userInfo;
        const params = { id: id, follow_id: opt.account_id }

        // this.setState({ load: true })
        this.props.postSubscribeList(params, res => {
            if (res) {
                //   this.getPostList()
                // }
                PostsData[index].following = "Y"
                this.setState({ PostsData })

            }
        })
    }
    handunfollow = (opt, index) => {
        const { PostsData } = this.state
        const { userInfo } = this.props;
        const { id } = userInfo;
        const params = { id: id, follow_id: opt.account_id }
        // this.setState({ load: true })
        this.props.postUnsubscribeList(params, res => {
            if (res) {
                PostsData[index].following = 'N'
                this.setState({ PostsData })
                // this.getPostList()
            }
        })
    }
    handthumbsup = (opt, index) => {
        let { PostsData } = this.state
        const params = {
            id: opt.nid,
            name: "node_posts_like",
            switch: opt.like === 'Y' ? 'N' : 'Y',
            versiontype: 'Services-Flag-Toggle-Version',
            versionnum: '1.1'
        }
        this.props.toggleFlag(params, res => {
            if (res.status === SERVICES_RESP.STATUS_OK) {
                PostsData[index].like = params.switch
                if (params.switch == 'Y') {
                    PostsData[index].dlike_counts += 1
                } else {
                    PostsData[index].dlike_counts -= 1
                }
                this.setState({ PostsData })
            }
        })
    }
    handcomment = (e, opt) => {
        const { iscomment } = this.state;
        e.stopPropagation()
        if (iscomment == opt.nid) {
            this.setState({ iscomment: "", isShowcomments: "", cid: null, replyName: null })
        } else {
            this.setState({
                iscomment: opt.nid,
                isShowcomments: opt.nid,
                cid: null,
                replyName: null
            })
        }
    }
    handisreport = (e, opt) => {
        const { isreport } = this.state;
        e.stopPropagation()
        if (isreport == opt.nid) {
            this.setState({ isreport: "" })
        } else {
            this.setState({ isreport: opt.nid })
        }
    }

    getPostList = () => {
        const { userInfo, language, marketParams } = this.props;
        const { id } = userInfo;
        if (!marketParams.stockCode) {
            this.setState({ load: false, PostsData: null })
            return
        }
        if (id) {
            // this.setState({ load: true })
            const params = {
                size: 50,
                uuid: id,
                versiontype: "Services-Customer-Posts-Version",
                versionnum: '1.1',
                instrument: marketParams.stockCode + ":" + marketParams.marketID
            }
            this.props.getCommentPostList(params, res => {
                if (res) {
                    this.setState({ PostsData: res.rows, load: false }, () => {
                    })
                }
            })
        }
    }
}


export default connect(
    (state) => ({
        language: state.app.language,
        mdsToken: state.trade.mdsToken,
        marketParams: state.trade.marketParams,
        userInfo: state.user.userInfo,
    }),
    (dispatch) => ({
        getCommentPostList: (p, c) => dispatch(userActions.getPostListAction(p, c)),
        postSubscribeList: (p, c) => dispatch(userActions.postSubscribeAction(p, c)),
        postUnsubscribeList: (p, c) => dispatch(userActions.postUnsubscribeAction(p, c)),
        toggleFlag: (p, res) => dispatch(forumActions.toggleFlagAction(p, res)),  //点赞
        writeComment: (p, res) => dispatch(forumActions.writeCommentAction(p, res)),
        replyComment: (p, c) => dispatch(userActions.getMarketCommentReplyAction(p, c))
    })
)(CommentMobile);

